import { ReactNode } from "react";

export enum EUserSettigs {
    // TODO: get rid of _ENG keys
    SOUND_ENG = "Sound",
    USER_ENG = "Profile Settings",
    APPERANCE_ENG = "Apperance",
    SOUND = "sound",
    USER = "profile",
    APPEARANCE = "appearance",
}

export interface IUserSettings {
    value: string;
    onChange: (event: React.SyntheticEvent, newValue: string) => void;
    tabSettingsContentList: {
        label: string;
        value: string;
        component: ReactNode;
    }[];
    appearanceTheme: string;
}

export interface IApperance {
    appearanceTheme: string;
}
